import { Controller } from "@hotwired/stimulus";

export default class ShareController extends Controller {
  static values = {
    url: String,
    type: String,
    id: Number,
    klass: String
  };

  popup() {
    const url = this.urlValue;
    const isSmallScreen = globalThis.screen.availWidth <= 768;

    const width = isSmallScreen
      ? globalThis.screen.availWidth
      : Math.min(Math.round(globalThis.screen.availWidth * 0.4), 600);

    let height = isSmallScreen
      ? globalThis.screen.availHeight
      : Math.min(Math.round(globalThis.screen.availHeight * 0.8), 800);

    height = height - (height * 30 / 100);
    const left = isSmallScreen
      ? 0
      : globalThis.screenX + (globalThis.outerWidth - width) / 2;

    const top = isSmallScreen
      ? 0
      : globalThis.screenY + (globalThis.outerHeight - height) / 2;

    globalThis.open(url, "share_dialog", `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);
  }
}
